import styled from 'styled-components';

import { media } from '../../../theme/media';
import { H2 } from '../../../theme/typography';
import { themeColor } from '../../../theme/getters';
import { getUnderLine } from '../../../theme/mixins';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 328px;
  margin-top: 32px;

  ${media.tablet`
    margin-top: 0;
    max-width: 408px;
  `};
`;

export const Title = styled(H2)`
  font-size: 32px;
  line-height: 42px;
  color: ${themeColor('gray')};
  margin-bottom: 16px;

  ${media.tablet`
    font-size: 45px;
    line-height: 53px;
    margin-bottom: 32px;
  `};
`;

export const Description = styled.p`
  padding: 0 16px;
  margin: 0 0 40px;
  font-size: 18px;
  line-height: 24px;
  color: ${themeColor('gray')};

  a {
    ${getUnderLine('darkMiddleGray')};
  }

  ${media.tablet`
    font-size: 20px;
    line-height: 27px;
  `};
`;
